import { useCallback, useEffect, useRef, useState } from 'react';
import { atom, useAtom } from 'jotai';
import { useScreenshot } from 'use-react-screenshot';
import { useTranslation } from '@ibk/shared-translation';
export const receiptDrawerAtom = atom(false);
export const receiptDrawerItemAtom = atom(null);
export const useDrawerReceipt = () => {
    const { t } = useTranslation();
    const [receiptDrawerVisible, setReceiptDrawerVisible] = useAtom(receiptDrawerAtom);
    const [receiptDrawerItem, setReceiptDrawerItem] = useAtom(receiptDrawerItemAtom);
    const [downloading, setDownloading] = useState(false);
    const downloadScreenshotRef = useRef(null);
    const [, takeScreenshot] = useScreenshot({ type: 'jpg', quality: 1.0 });
    useEffect(() => {
        if (downloading && downloadScreenshotRef.current) {
            takeScreenshot(downloadScreenshotRef.current)
                .then((file) => {
                const a = document.createElement('a');
                a.href = file;
                a.download = `${t('receipt.drawer.title').toLowerCase()}.jpg`;
                a.click();
            })
                .catch(() => { })
                .finally(() => {
                setDownloading(false);
            });
        }
    }, [downloading, downloadScreenshotRef, takeScreenshot, t]);
    const handleOpenDrawer = useCallback((item) => {
        setReceiptDrawerItem(item);
        setReceiptDrawerVisible(true);
    }, [setReceiptDrawerVisible, setReceiptDrawerItem]);
    const handleCloseDrawer = useCallback(() => {
        setReceiptDrawerVisible(false);
        setReceiptDrawerItem(null);
    }, [setReceiptDrawerVisible, setReceiptDrawerItem]);
    const handleShareReceipt = useCallback(() => {
        setDownloading(true);
    }, []);
    const states = {
        receiptDrawerVisible,
        receiptDrawerItem,
        downloading,
        downloadScreenshotRef,
    };
    const actions = {
        handleOpenDrawer,
        handleCloseDrawer,
        handleShareReceipt,
    };
    return {
        states,
        actions,
    };
};
